$(document).ready(function() {
	$('#projects').lightGallery({
		// thumbnail: true,
		// animateThumb: false,
		// showThumbByDefault: false,
		selector: '.project-item'
	});

})